/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getHealthStatus} from '../api'

 export const useQueryGetHealthStatus = createReactQueryHook('getHealthStatus', getHealthStatus)
